import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { BREAKPOINTS } from '../utilities/index.js';

(function() {
  "use strict";

  class SliderList {
    constructor(wrap) {
      this.wrap = wrap;

      const elm = this.wrap.querySelector('.swiper');
      const next = this.wrap.querySelector('.swiper-button-next');
      const prev = this.wrap.querySelector('.swiper-button-prev');
      const page = this.wrap.querySelector('.swiper-pagination');
      this.swiper = new Swiper(elm, {
        modules: [Navigation, Pagination],
        loop: true,
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 5,
        breakpoints: {
          [BREAKPOINTS.desktop]: {
            slidesPerView: 1.351,
            spaceBetween: 8,
          }
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        pagination: {
          el: page,
          type: "fraction",
        },
      });
    }

  }

  document.querySelectorAll('.c-sliderPhoto').forEach((wrap) => {
    new SliderList(wrap);
  });


})();